import React from "react";

const baseStyles = {
  container: {
    padding: "18px 0 8px",
  },
  top: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  left: {
    display: "flex",
    gap: 12,
    alignItems: "center",
  },
  back: {
    cursor: "pointer",
    flexShrink: 0,
    fontSize: 22,
    fontWeight: 700,
    color: "var(--primary)",
    marginTop: 4,
  },
  title: {
    margin: 0,
    fontWeight: 700,
    fontSize: 22,
    lineHeight: 1.15,
    letterSpacing: "0.3px",
    color: "var(--on-bg)",
  },
  subtitle: {
    fontSize: 12,
    marginTop: 4,
    marginBottom: 0,
    marginLeft: 34,
    textAlign: "left",
  },
};

export default function FeatureHeader({
  title,
  subtitle,
  onBack,
  rightSlot = null,
  containerStyle,
  topStyle,
  leftStyle,
  backStyle,
  titleStyle,
  subtitleStyle,
  subtitleClassName = "text-secondary",
}) {
  return (
    <div style={{ ...baseStyles.container, ...containerStyle }}>
      <div style={{ ...baseStyles.top, ...topStyle }}>
        <div style={{ ...baseStyles.left, ...leftStyle }}>
          <i className="fi fi-br-angle-left" onClick={onBack} style={{ ...baseStyles.back, ...backStyle }} />
          <h5 style={{ ...baseStyles.title, ...titleStyle }}>{title}</h5>
        </div>
        {rightSlot}
      </div>
      {subtitle ? (
        <p className={subtitleClassName} style={{ ...baseStyles.subtitle, ...subtitleStyle }}>
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}
